<template class="template-intention-train">
    <div class="intention-train">
        <div class="content">
            <div class="title">
                <div class="msg-head">意图管理</div>
                <div class="info">
                    <span>已训练样本：</span>
                    <span style="color:rgba(34, 215, 187, 1);margin-right:20px">{{trainedCount}}</span>
                    <span>待训练样本：</span>
                    <span style="color:rgba(34, 215, 187, 1);margin-right:20px">{{unTrainedCount}}</span>
                    <a-button v-if="!currentTrainState" @click="startTrain" class="train">训练</a-button>
                    <a-button v-if="currentTrainState" type="primary" disabled style="border:none">训练中...</a-button>
                    <a-button @click="globalCirrus" style="height:34px;margin-left:20px;" type="primary">全局卷云</a-button>
                </div>
            </div>
            <div class="msg" style="overflow-y:auto;overflow-x:hidden">
                <div class="gutter-example">
                    <a-row :gutter="16">
                        <a-col class="gutter-row" :span="7">
                            <div class="gutter-box">
                                <div class="box-head">
                                    <div class="intention-list-head">意图列表</div>
                                    <div class="intention-search">
                                        <a-input-search class="intention-input" 
                                        v-model="keyword"
                                        placeholder="请输入搜索内容" style="width: 80%;border:1px solid rgba(238, 238, 238, 1)" @search="onSearch1" />
                                    </div>
                                </div>
                                <div class="box-content">
                                    <ul>
                                        <li style="flex: 1;display: flex;" :class="{'active':selectItem==index}" v-for="(item, index) in intentionListData" :key="index" @click="selectCurrent(item,index)">
                                            <span style="flex: 1;overflow:hidden" :title="item.name">{{item.name}}</span>
                                            <div class="li-des">
                                                <span>{{item.sampleCount}}</span>
                                                <a-icon type="edit" @click="showEditNameModel(item.name,item.id)" />
                                                <a-icon type="delete" @click="confirmDelete(item.id)" />
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="currentTotal1 != total1" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="onChangePage1">点击加载更多</div>
                                    <div v-if="currentTotal1 == total1" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                </div>
                                <div class="box-foot">
                                    <span class="span-icon" @click="showModal">
                                        新增
                                    </span>
                                </div>
                            </div>
                        </a-col>
                        <a-col class="gutter-row" :span="10">
                            <div class="gutter-box">
                                <div class="box-head">
                                    <div class="intention-list-head">意图样本</div>
                                    <div class="intention-tab">
                                        <span @click="ifTrain(1)" :class="{'active':ifTrainState==1}">反卷云</span>
                                        <span style="border-left:1px solid #22d7bb;border-right:1px solid #22d7bb" @click="ifTrain(0)" :class="{'active':ifTrainState==0}">已训练</span>
                                        <span @click="ifTrain(2)" :class="{'active':ifTrainState==2}">待训练</span>
                                    </div>
                                    <a-input-search v-model="searchContent" placeholder="请输入搜索内容" style="width: 200px;margin-left:20px;float:left;margin-top:12px;" @search="filterSample" />
                                </div>
                                <div class="box-content">
                                    <div v-if='ifTrainState==1' style="position:relative;">
                                        <a-icon v-if="ifShowHasTrain" style="position:absolute;left:50%;top:200px;z-index:100;font-size:24px;color:#22d7bb;" type="loading" />
                                        <div style="padding:5px 0 4px 10px;">
                                            <a-row style="display:inline-block;width:100%;line-height:30px;height:20px;">
                                                <a-col :span="12">
                                                    <div v-if="hasTrainData.length!=0" style="display:inline-block;">
                                                        <a-checkbox :checked="checkAll1" @change="checkAllHasTrain"></a-checkbox>
                                                        全选
                                                    </div>
                                                </a-col>
                                                <a-col :span="8">
                                                    <span style="padding-left:15px;">类似意图</span>
                                                </a-col>
                                                <a-col :span="4">
                                                    <div style="display:inline-block;text-align:right;float:left;color:rgba(34, 215, 187, 1);cursor:pointer;padding-left:16px;">
                                                        <span @click="orderNewList">
                                                            <a-icon type="ordered-list" />
                                                            排序
                                                        </span>
                                                    </div>
                                                </a-col>
                                            </a-row>
                                        </div>
                                        <ul class="train" style="overflow:hidden;">
                                            <a-checkbox-group v-if="hasTrainData.length>0" @change="trainSelectedChange" v-model="checkedHasTrainList">
                                                <a-checkbox :value="item.value"  v-for="(item, index) in hasTrainData" :key="index">
                                                    <a-row style="display:inline-block;width:90%;line-height:30px;height:20px;">
                                                        <a-col :span="13">
                                                            <span :title='item.label' style="display:inline-block;float:left;overflow:hidden;width:100%;height:30px;">{{item.label}}</span>
                                                        </a-col>
                                                        <a-col :span="9">
                                                            <span :title='item.otherIntention' style="display:inline-block;float:left;overflow:hidden;width:100%;height:30px;">{{item.otherIntention}}</span>
                                                        </a-col>
                                                        <a-col :span="2">
                                                            <span style="display:inline-block;width:60px;float:left">{{item.score}}</span>
                                                        </a-col>
                                                       
                                                    </a-row>
                                                </a-checkbox>
                                            </a-checkbox-group>
                                        </ul>
                                        <div v-if="currentTotal2 != total2" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="nextPageTrainData">点击加载更多</div>
                                        <div v-if="currentTotal2 == total2" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                    </div>
                                    <div v-if='ifTrainState==0' style="position:relative;">
                                        <a-icon v-if="ifShowNewHasTrain" style="position:absolute;left:50%;top:200px;z-index:100;font-size:24px;color:#22d7bb;" type="loading" />
                                        <div style="padding:5px 0 4px 10px;">
                                            <a-row style="display:inline-block;width:100%;line-height:30px;height:20px;">
                                                <a-col :span="12">
                                                    <div v-if="hasNewTrainData.length!=0" style="display:inline-block;">
                                                        <a-checkbox :checked="checkAllNew" @change="checkNewAllHasTrain"></a-checkbox>
                                                        全选
                                                    </div>
                                                </a-col>
                                            </a-row>
                                        </div>
                                        <ul class="train" style="overflow:hidden;">
                                            <a-checkbox-group v-if="hasNewTrainData.length>0" @change="trainNewSelectedChange" v-model="checkedNewHasTrainList">
                                                <a-checkbox :value="item.value"  v-for="(item, index) in hasNewTrainData" :key="index">
                                                    <a-row style="display:inline-block;width:90%;line-height:30px;height:20px;">
                                                        <a-col :span="13">
                                                            <span :title='item.label' style="display:inline-block;float:left;overflow:hidden;width:100%;height:30px;">{{item.label}}</span>
                                                        </a-col>
                                                    </a-row>
                                                </a-checkbox>
                                            </a-checkbox-group>
                                        </ul>
                                        <div v-if="currentNewTotal2 != total2New" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="nextNewPageTrainData">点击加载更多</div>
                                        <div v-if="currentNewTotal2 == total2New" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                    </div>
                                    <div v-if='ifTrainState==2'>
                                        <a-icon v-if="ifShowUnTrain" style="position:absolute;left:50%;top:200px;z-index:100;font-size:24px;color:#22d7bb;" type="loading" />
                                        <div v-if="unTrainData.length!=0" style="padding:5px 0 4px 10px;">
                                            <a-checkbox :checked="checkAll2" @change="checkAllUnTrain"></a-checkbox>
                                            全选
                                        </div>
                                        <ul class="untrain">
                                            <a-checkbox-group v-if="unTrainData.length>0" v-model="checkedUnTrainList" :options="unTrainData" @change="onChangeBox2" style="width:100%;padding-left:0px">
                                            </a-checkbox-group>
                                        </ul>
                                        <div v-if="currentTotal3 != total3" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="nextPageUnTrainData">点击加载更多</div>
                                        <div v-if="currentTotal3 == total3" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                    </div>
                                </div>
                                <div class="box-foot">
                                    <a-button @click="removeSample">移除样本</a-button>
                                </div>
                            </div>
                        </a-col>
                        <a-col class="gutter-row" :span="7">
                            <div class="gutter-box">
                                <div class="box-head">
                                    <div class="intention-list-head">新增样本</div>
                                    <div class="intention-tab">
                                        <span @click="ifTrain(3)" :class="{'active':addSample==3}">输入</span>
                                        <span @click="ifTrain(4)" style="border-left:1px solid rgba(34, 215, 187, 1);" :class="{'active':addSample==4}">搜索</span>
                                        <!-- <span @click="ifTrain(5)" :class="{'active':addSample==5}">推荐</span> -->
                                    </div>
                                </div>
                                <div class="box-content add-sample">
                                    <div v-if="addSample==3" style="height:100%">
                                        <a-textarea v-model="content" style="height:100%;border:none;resize: none" placeholder="请输入新增样本" autoSize />
                                    </div>
                                    <div v-if="addSample==4" style="height:100%;display: flex;flex-direction: column;position:relateve">
                                        <div style="position:absolute;left:0px;top:0px;width:100%;padding:16px 16px;">
                                            <a-input-search v-model="searchKeyword" class="" placeholder="请输入搜索内容" style="width: 100%;height: 30px;color:1px solid rgba(238, 238, 238, 1)" @search="querySampleList(0)" />
                                        </div>
                                        <ul style="margin-top:30px">
                                            <a-checkbox-group v-if="currentSampleData.length>0" @change="onChangeSample" style="width:100%">
                                                <li style="overflow:hidden" v-for="(waitItem, waitIndex) in currentSampleData" :key="waitIndex">
                                                    <a-checkbox :value='waitItem'></a-checkbox>
                                                    <span :title="waitItem">{{waitItem}}</span>
                                                </li>
                                            </a-checkbox-group>
                                        </ul>
                                        <div v-if="currentSampleTotal != sampleTotal" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="loadMoreSample">点击加载更多</div>
                                        <div v-if="currentSampleTotal == sampleTotal" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                        <a-spin v-if="ifshowLoadSample" style="position:absolute;left:50%;top:45%"/>
                                    </div>
                                </div>
                                <div v-if="addSample==3" class="box-foot">
                                    <a-button @click="addIntoSample(1)">加入样本</a-button>
                                </div>
                                <div v-if="addSample==4" class="box-foot">
                                    <a-button @click="addIntoSample(2)">加入样本</a-button>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </div>
        <a-modal
            :mask-closable="true"
            title="意图名称"
            :visible="ifShowEditNameModel"
            @ok="sureChangeName"
            @cancel="handleCancel"
            okText="确认" cancelText="取消"
            >
            <div class="">
                <a-input v-model="newIntentionName" />
            </div>
        </a-modal>
        <a-modal
            :mask-closable="true"
            title="新建意图"
            :visible="intentionModal"
            :footer="null"
            width="1058px"
            @cancel="offIntention"
            >
            <a-tabs default-active-key="1">
                <a-tab-pane key="1">
                    <span slot="tab" style="font-size:16px;">
                        <a-icon type="switcher" />
                        自主创建
                    </span>
                    <div style="padding-bottom:50px;">
                        <div style="font-size:18px;color:rgba(51, 51, 51, 1)">自定义名称</div>
                        <div style="margin-top:16px;">
                            <span style="color:rgba(153, 153, 153, 1);font-size:14px;">意图名称：</span>
                            <a-input v-model="intentionName" style="width:500px;height:34px;" placeholder="请输入意图名称" />
                            <span @click="handleOk" style="display:inline-block;width:80px;height:34px;text-align:center;line-height:34px;border-radius:4px;color:#fff;background:rgba(34, 215, 187, 1);margin-left:24px;font-size:14px;cursor:pointer">确定</span>
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2">
                    <span slot="tab" style="font-size:16px;">
                        <a-icon type="cloud-server" />
                        云意图库
                    </span>
                    <div>
                        <div style="color:rgba(51, 51, 51, 1);font-size:18px">搜索条件</div>
                        <div style="margin-top:16px;border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:24px;">
                            <a-row>
                                <a-col :span="8">
                                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-bottom:8px">基本搜索：</div>
                                    <a-input-search
                                        placeholder="请输入搜索内容"
                                        @search="onSearch"
                                        style="width:250px;height:32px;"
                                        v-model="keywordValue"
                                    />
                                </a-col>
                                <a-col :span="8">
                                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-bottom:8px">场景类型：</div>
                                    <a-select style="width:250px;"
                                        placeholder="不限"
                                        @change="handleSelectChange1"
                                    >
                                        <a-select-option title="不限" value="">
                                        不限
                                        </a-select-option>
                                        <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in sceneList" :key="index">
                                        {{item.name}}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="8">
                                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-bottom:8px">样本数量：</div>
                                    <a-select style="width:250px;"
                                        placeholder="不限"
                                        @change="handleSelectChange2"
                                    >
                                        <a-select-option title="不限" value="">
                                        不限
                                        </a-select-option>
                                        <a-select-option title="1-20" value="1">
                                        1-20
                                        </a-select-option>
                                        <a-select-option title="21-50" value="2">
                                        21-50
                                        </a-select-option>
                                        <a-select-option title="51-200" value="3">
                                        51-200
                                        </a-select-option>
                                        <a-select-option title="201-500" value="4">
                                        201-500
                                        </a-select-option>
                                        <a-select-option title="500以上" value="5">
                                        500以上
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                            </a-row>
                        </div>
                        <div class="intention-content" style="margin-top:24px;">
                            <a-row :gutter="16" style="height:100%">
                                <a-col class="gutter-row" :span="12" style="height:100%;display:flex;flex-direction: column">
                                    <div class="title" style="height:30px;color:rgba(51, 51, 51, 1);font-size:18px">意图列表</div>
                                    <div class="gutter-box">
                                        <div style="overflow-y:auto;padding-bottom:24px;max-height:500px">
                                            <a-table
                                                :data-source="data"  
                                                :customRow="rowClick" 
                                                :pagination='false' 
                                                class="cloudy-table" 
                                                :rowKey="record => record.id"
                                            >
                                                <a-table-column key="name" title="意图名称" data-index="name">
                                                    <template slot-scope="text, record">
                                                        <div :class="{'active':currentId==record.id}">
                                                            {{record.name}}
                                                        </div>
                                                    </template>
                                                </a-table-column>
                                                <a-table-column key="action" title="样本数量" class="table-sample">
                                                    <template slot-scope="text, record">
                                                        <div :class="{'active':currentId==record.id}">
                                                            <span>{{ record.sampleCount }}</span>
                                                            <a-icon type="download" v-if="isLogin" @click="saveToSelf(record.id)"/>
                                                        </div>
                                                    </template>
                                                </a-table-column>
                                            </a-table>
                                            <div v-if="ifShowLoadMore1" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="onChangeSample1">点击加载更多</div>
                                            <div v-if="!ifShowLoadMore1 && total4 != 0" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                        </div>
                                    </div>
                                </a-col>
                                <a-col class="gutter-row" :span="12" style="height:100%;display:flex;flex-direction: column">
                                    <div class="title" style="height:30px;color:rgba(51, 51, 51, 1);font-size:18px">意图样本</div>
                                    <div class="gutter-box ">
                                    <div class="sample" style="overflow-y:auto;padding-bottom:24px;max-height:500px">
                                        <a-table :columns="columnsSample" :dataSource="intentionSampleList" :pagination='false'>
                                        </a-table>
                                        <div v-if="ifShowLoadMore2" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(34, 215, 187, 1);font-size:12px" @click="onChangeSample2">点击加载更多</div>
                                        <div v-if="!ifShowLoadMore2 && total2 != 0" style="text-align:center;cursor:pointer;margin-top:15px;color:rgba(170, 170, 170, 1);font-size:12px;">已经没有啦~</div>
                                    </div>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>

                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-modal>
        <a-modal
            :mask-closable="true"
            title="全局卷云"
            :visible="ifShowGlobalCirrus"
            :footer="null"
            width="1058px"
            @cancel="closeGlobalCirrus"
        >
            <div class="">
                <div>
                    <span style="color:rgba(128, 128, 128, 1);font-size:14px;">选择时间：</span>
                    <a-range-picker
                        :locale="locale"
                        style="width:500px;"
                        :disabled-date="disabledDate2"
                        @change="changeRecommendText"
                        :show-time="{
                            hideDisabledOptions: true,
                            defaultValue: [moment(), moment()],
                        }"
                        format="YYYY-MM-DD"
                    />
                    <span @click="searchTimeSample" style="display:inline-block;width:80px;height:32px;text-align:center;line-height:32px;color:#fff;background:rgba(34, 215, 187, 1);font-size:14px;border-radius:4px;cursor:pointer;float:right;">搜索</span>
                </div>
                <div style="margin-top:20px;">
                    <div>
                        <span style="color:rgba(34, 215, 187, 1);font-size:14px">{{completedData}}</span>
                        <a-progress :percent="percentProgress" :showInfo='false' status="active" strokeColor='rgba(34, 215, 187, 1)' style="width:55%;margin:0 15px;" />
                        <span style="color:rgba(153, 153, 153, 1);font-size:14px;">{{totalCount}}</span>
                        <div style="display:inline-block;" v-if="ifshowCirrus">
                            <div @click="startCirrus()" v-if="batchNo!=1" style="display:inline-block;color:rgba(34, 215, 187, 1);font-size:14px;margin-left:16px;cursor:pointer;">
                                <a-icon type="sync" />
                                <span style="margin-left:4px;">下一批</span>
                            </div>
                            <span v-if="batchNo==1" @click="startCirrus()" style="color:rgba(34, 215, 187, 1);font-size:14px;margin-left:16px;cursor:pointer;">开始卷云</span>
                        </div>
                    </div>
                    <div v-if="ifshowCirrus">
                        <div style="padding:5px 0 4px 10px;background:#F5F6F7;margin-top:24px;">
                            <a-row>
                                <a-col :span="8">
                                    <div v-if="sampleList.length!=0" style="display:inline-block;">
                                        <a-checkbox :checked="checkAll3" @change="selectAllSupportData"></a-checkbox>
                                        全选
                                    </div>
                                    <span>样本</span>
                                </a-col>
                                <a-col :span="8">
                                    <span>意图名称</span>
                                    <a-select placeholder='请选择' style="width: 200px;margin-left:24px;height:28px;" @change="changeIntention">
                                        <a-select-option value="">全部</a-select-option>
                                        <a-select-option :value="item" v-for="(item, index) in selectIntentionList" :key="index">
                                            {{item}}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="8">
                                    <div style="display:inline-block;text-align:right;float:right;padding-right:24px;color:rgba(34, 215, 187, 1);cursor:pointer;">
                                        <span @click="orderSupportList">
                                            <a-icon type="ordered-list" />
                                            排序
                                        </span>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                        <ul class="train" style="overflow:hidden;">
                            <a-checkbox-group style="min-height:300px;" v-if="sampleList.length>0" @change="supportSelectedChange" v-model="checkedSupportList">
                                <a-checkbox :value="item.content+'@@'+item.intentionId"  v-for="(item, index) in sampleList" :key="index">
                                    <span style="display:inline-block;width:31%;">{{item.content}}</span>
                                    <span style="">{{item.intentionName}}</span>
                                    <span style="display:inline-block;width:60px;float:right">{{(item.score).toFixed(2)}}</span>
                                </a-checkbox>
                            </a-checkbox-group>
                            <div v-if="sampleList.length==0" style="text-align:center;line-height:300px;min-height:300px;color:rgba(128, 128, 128, 1);font-size:16px;">
                                暂无数据
                            </div>
                        </ul>
                        <div class="box-model-foot" style="text-align:center;">
                            <a-button @click="addIntoSample(3)">加入样本</a-button>
                        </div>
                    </div>
                    <div v-if="!ifshowCirrus" style="text-align:center;line-height:300px;min-height:300px;color:rgba(128, 128, 128, 1);font-size:16px;">
                        暂无数据
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
// import axios from 'axios';
const columns = [
  {
    title: '意图名称',
    key: 'name',
    dataIndex: 'name',
    id: 'id'
  },
  {
    title: '样本数量',
    key: 'sampleCount',
    dataIndex: 'sampleCount',
    id: 'id'
  },
];
const columnsSample = [
  {
    title: '样本内容',
    key: 'content',
    dataIndex: 'content',
  },
];
export default {
    name: 'IntentionTrain',
    props: {
        msg: String
    },
    data() {
        return {
            locale,
            ifTrainState: 2,
            addSample: 3,
            size: 50,
            keyword: '',
            projectId: '',
            intentionListData: [],
            current1: 1,
            intentionName: '',
            trainedCount: 0,
            unTrainedCount: 0,
            content: '',
            intentionId: '',
            currentTrainDataTrue: 1,
            hasTrainTotal: 0,
            hasTrainData: [],
            currentUnTrainDataFalse:1,
            unTrainData: [],
            removeTrainSample: [],
            removeUnTrainSample: [],
            selectItem: '',
            total1: 0,
            currentTotal1: 0,
            total2: 0,
            currentTotal2: 0,
            total3: 0,
            currentTotal3: 0,
            total4: 0,
            currentTotal4: 0,
            currentTrainState: false,
            searchKeyword: '',
            searchCurrent: 1,
            currentSampleTotal: 0,
            sampleTotal: 0,
            currentSampleData: [],
            selectedSampleList: [],
            selectedSampleStr: '',
            ifshowLoadSample: false,
            ifShowEditNameModel: false,
            newIntentionName: '',
            currentIntentionId: '',
            checkAll1: false,
            checkedHasTrainList: [],
            checkAll2: false,
            checkedUnTrainList: [],
            intentionModal: false,
            keywordValue: '',
            intentionSampleList: [],
            sceneList: [],
            data: [],
            columns,
            keywordData: '',
            sceneId: '',
            minSampleCount: '',
            maxSampleCount: '',
            sampleKeyword: '',
            current: 1,
            columnsSample,
            currentSample: 1,
            recordData: null,
            visible: false,
            proList: [],
            demodata: '请选择',
            isLogin: false,
            ifShowLoadMore1: false,
            ifShowLoadMore2: false,
            currentId: '',
            defaultTime: ['开始时间','结束时间'],
            startTime: '',
            endTime: '',
            searchContent: '',
            totalCount: 0,
            completedData: 0,
            batchNo: 1,
            sampleList: [],
            percentProgress: 0,
            ifshowCirrus: false,
            checkAll3: false,
            checkedSupportList: [],
            selectedSupportList: [],
            sourceTrue: null,
            sourceFalse: null,
            offsetDays: 86400000 * 7,
            selectPriceDate: '',
            ifShowSearchLoading: false,
            ifShowHasTrain: false,
            ifShowUnTrain: false,
            ifShowGlobalCirrus: false,
            trainTime: '',
            selectPriceDate2: '',
            startTime2: '',
            endTime2: '',
            selectIntentionList: [],
            newSampleList: [],
            ifShowNewHasTrain: false,
            hasNewTrainData: [],
            checkAllNew: false,
            checkedNewHasTrainList: [],
            currentNewTotal2: 0,
            total2New: 0,
            currentNewTrainDataTrue: 1,
            removeNewTrainSample: [],
        };
    },
    
    methods: {
        /*
            *queryIntentionList(params) params:0初始化，1下一页，2添加意图,3改名,4新增样本
            *
            * 
            * 
        */
        moment,
        queryNewTrainDataTrue(type) {
            if(type == 0){
                this.hasNewTrainData = []
            }
            this.ifShowNewHasTrain = true
            this.cancelRequestTrue(); 
            // const _this = this;
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/list', 
                    params: {
                        current: this.currentNewTrainDataTrue,
                        size: this.size,
                        intentionId: this.intentionId,
                        hasTrained: true,
                        keyword: this.searchContent,
                        isNplPredict: false
                    },
                }
            )
            .then(response=> {
                this.ifShowNewHasTrain = false
                if(response.data.code == 0){
                    this.total2New = response.data.data.total
                    for(let i = 0; i < response.data.data.records.length; i++){
                        let obj = {}
                        obj.label = response.data.data.records[i]['content']
                        obj.value = response.data.data.records[i]['id']
                        obj.otherIntention = response.data.data.records[i]['otherIntention']
                        obj.score = response.data.data.records[i]['otherScore']=='--'?'--':Number((response.data.data.records[i]['otherScore']))
                        this.hasNewTrainData.push(obj)
                    }
                    this.removeNewTrainSample = []
                    this.currentNewTotal2 = this.hasNewTrainData.length
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                this.ifShowNewHasTrain = false
                console.log(error)
            }) 
        },
        nextNewPageTrainData() {
            this.currentNewTrainDataTrue ++
            this.queryNewTrainDataTrue(1)
        },
        trainNewSelectedChange(e) {
            this.removeNewTrainSample = e
            this.checkedNewHasTrainList = e
            this.checkAllNew = this.removeNewTrainSample.length === this.hasNewTrainData.length;
        },
        checkNewAllHasTrain(e) {
            this.checkAllNew = e.target.checked
            if(e.target.checked){
                let arr = []
                for(let i = 0; i < this.hasNewTrainData.length; i++){
                    arr.push(this.hasNewTrainData[i].value)
                }
                this.checkedNewHasTrainList = arr
            }else{
                this.checkedNewHasTrainList = []
            }
            this.removeNewTrainSample = this.checkedNewHasTrainList
        },
        changeIntention(value) {
            this.checkedSupportList = []
            this.checkAll3 = false
            let arr = []
            for(let i = 0; i < this.newSampleList.length; i++){
                if(value == ''){
                    arr.push(this.newSampleList[i])
                }else{
                    if(this.newSampleList[i]['intentionName'] == value){
                        arr.push(this.newSampleList[i])
                    }
                }
            }
            this.sampleList = arr
        },
        changeRecommendText2(date, dateString) {
            this.startTime = dateString[0]
            this.endTime = dateString[1]
            this.selectPriceDate = ''
        },
        range(start, end) {
            const result = [];
            for (let i = start; i < end; i++) {
                result.push(i);
            }
            return result;
        },
        disabledDate2(current) {
            return current < new Date(this.trainTime);
        },
        globalCirrus() {
            this.ifShowGlobalCirrus = true
        },
        closeGlobalCirrus() {
            this.ifShowGlobalCirrus = false
        },
        calendarPriceRangeChange(date){
            this.selectPriceDate = date[0]
        },
        disabledDate(current){
            if(this.selectPriceDate){
                let selectV = moment(this.selectPriceDate, 'YYYY-MM-DD').valueOf()
                return current > moment(new Date(selectV+this.offsetDays), 'YYYY-MM-DD') ||
                    current < moment(new Date(selectV-this.offsetDays), 'YYYY-MM-DD')
            }else{
                return false
            }
        },
        selectAllSupportData(e) {
            this.checkAll3 = e.target.checked
            if(e.target.checked){
                let arr = []
                for(let i = 0; i < this.sampleList.length; i++){
                    arr.push(this.sampleList[i].content+'@@'+this.sampleList[i].intentionId)
                }
                this.checkedSupportList = arr
            }else{
                this.checkedSupportList = []
            }
            this.selectedSupportList = this.checkedSupportList
        },
        orderSupportList() {
            let data = this.JsonSort(this.sampleList,'score')
            this.sampleList = data
            this.$forceUpdate();
        },
        supportSelectedChange(e) {
            this.selectedSupportList = e
            this.checkedSupportList = e
            this.checkAll3 = this.selectedSupportList.length === this.sampleList.length;
        },
        startCirrus() {
            this.ifShowSearchLoading = true
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/searchByDate', 
                    params: {
                        projectId: this.projectId,
                        batchNo: this.batchNo
                    }
                }
            )
            .then(response=> {
                this.ifShowSearchLoading = false
                if(response.data.code == 0){
                    this.completedData = response.data.data.finishCount
                    this.sampleList = response.data.data.sampleList
                    let arr = []
                    if(this.sampleList.length > 0){
                        this.batchNo ++
                        for(let i = 0; i < this.sampleList.length; i++){
                            if(this.sampleList[i]['content']!=''){
                                arr.push(this.sampleList[i])
                                this.selectIntentionList.push(this.sampleList[i]['intentionName'])
                            }
                        }
                        this.sampleList = arr
                        this.newSampleList = arr
                        this.selectIntentionList = this.unique(this.selectIntentionList)
                    }
                    if(this.totalCount == 0) {
                        this.percentProgress = 0
                    }else{
                        this.percentProgress = this.completedData/this.totalCount*100
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        searchTimeSample() {
            this.ifShowSearchLoading = true
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/countByDate', 
                    params: {
                        startDate: this.startTime,
                        endDate: this.endTime,
                        projectId: this.projectId,
                    }
                }
            )
            .then(response=> {
                this.ifShowSearchLoading = false
                if(response.data.code == 0){
                    this.ifshowCirrus = true
                    this.totalCount = response.data.data.totalCount
                    this.batchNo = 1
                    this.checkedSupportList = []
                    this.selectedSupportList = []
                    this.checkAll3 = false
                    this.sampleList = []
                    this.selectIntentionList = []
                    this.completedData = 0
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        onSearch1(value) {
            this.keyword = value
            this.queryIntentionList(0)
        },
        onChangePage1() {
            this.current1 ++
            this.queryIntentionList(1)
        },
        onChangeSample(e) {
            this.selectedSampleList = e
        },
        onChangeBox1(value) {
            this.removeTrainSample = value
            this.checkAll1 = this.checkedHasTrainList.length === this.hasTrainData.length;
        },
        trainSelectedChange(e) {
            this.removeTrainSample = e
            this.checkedHasTrainList = e
            this.checkAll1 = this.removeTrainSample.length === this.hasTrainData.length;
        },
        JsonSort(json, key){
            for(var j = 1,jl = json.length; j < jl; j++){
                var temp = json[j],
                    val = temp[key],
                    i = j-1;
                while(i >= 0 && json[i][key] > val){
                    json[i+1] = json[i];
                    i = i-1;    
                }
                json[i+1] = temp;
            }
            json.reverse()
            return json;
        },
        orderNewList() {
            let data = this.JsonSort(this.hasTrainData,'score')
            this.hasTrainData = data
            this.$forceUpdate();
        },
        checkAllHasTrain(e) {
            this.checkAll1 = e.target.checked
            if(e.target.checked){
                let arr = []
                for(let i = 0; i < this.hasTrainData.length; i++){
                    arr.push(this.hasTrainData[i].value)
                }
                this.checkedHasTrainList = arr
            }else{
                this.checkedHasTrainList = []
            }
            this.removeTrainSample = this.checkedHasTrainList
        },
        onChangeBox2(value) {
            this.removeUnTrainSample = value
            this.checkAll2 = this.checkedUnTrainList.length === this.unTrainData.length;
        },
        checkAllUnTrain(e) {
            this.checkAll2 = e.target.checked
            if(e.target.checked){
                let arr = []
                for(let i = 0; i < this.unTrainData.length; i++){
                    arr.push(this.unTrainData[i].value)
                }
                this.checkedUnTrainList = arr
            }else{
                this.checkedUnTrainList = []
            }
            this.removeUnTrainSample = this.checkedUnTrainList
        },
        removeSample() {
            let newArr = []
            if(this.ifTrainState==1){
                newArr = this.removeTrainSample
            }else if(this.ifTrainState==2){
                newArr = this.removeUnTrainSample
            }else if(this.ifTrainState==0){
                newArr = this.removeNewTrainSample
            }
            this.axios.post('/api/intention/sample/delete', {
                ids: newArr,
            })
            .then(response=> {
                if(response.data.code == 0){
                    if(this.ifTrainState==1){
                        this.queryTrainDataTrue(0)
                        this.queryNewTrainDataTrue(0)
                    }else if(this.ifTrainState==2){
                        this.queryTrainDataFalse(0)
                    }else if(this.ifTrainState==0){
                        this.queryNewTrainDataTrue(0)
                        this.queryTrainDataTrue(0)
                    }
                    this.queryIntentionList(3)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        ifTrain(type) {
            if(type == 0){
                this.ifTrainState = 0
            }else if(type == 1){
                this.ifTrainState = 1
            }else if(type == 2){
                this.ifTrainState = 2
            }else if(type == 3){
                this.addSample = 3
            }else if(type == 4){
                this.addSample = 4
            }
        },
        queryTrainDataTrue(type) {
            if(type == 0){
                this.hasTrainData = []
            }
            this.ifShowHasTrain = true
            this.cancelRequestTrue(); 
            // const _this = this;
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/list', 
                    params: {
                        current: this.currentTrainDataTrue,
                        size: this.size,
                        intentionId: this.intentionId,
                        hasTrained: true,
                        keyword: this.searchContent,
                        isNplPredict: true
                    },
                }
            )
            .then(response=> {
                this.ifShowHasTrain = false
                if(response.data.code == 0){
                    this.total2 = response.data.data.total
                    for(let i = 0; i < response.data.data.records.length; i++){
                        let obj = {}
                        obj.label = response.data.data.records[i]['content']
                        obj.value = response.data.data.records[i]['id']
                        obj.otherIntention = response.data.data.records[i]['otherIntention']
                        obj.score = response.data.data.records[i]['otherScore']=='--'?'--':Number((response.data.data.records[i]['otherScore']))
                        this.hasTrainData.push(obj)
                    }
                    this.removeTrainSample = []
                    this.currentTotal2 = this.hasTrainData.length
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        nextPageTrainData() {
            this.currentTrainDataTrue ++
            this.queryTrainDataTrue(1)
        },
        queryTrainDataFalse(type) {
            this.ifShow2 = true
            if(type == 0){
                this.unTrainData = []
            }
            this.ifShowUnTrain = true
            this.cancelRequestFalse(); 
            // const _this = this;
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/list', 
                    params: {
                        current: this.currentUnTrainDataFalse,
                        size: this.size,
                        intentionId: this.intentionId,
                        hasTrained: false,
                        keyword: this.searchContent
                    },
                }
            )
            .then(response=> {
                this.ifShowUnTrain = false
                if(response.data.code == 0){
                    for(let i = 0; i < response.data.data.records.length; i++){
                        let obj = {}
                        obj.label = response.data.data.records[i]['content']
                        obj.value = response.data.data.records[i]['id']
                        this.unTrainData.push(obj)
                    }
                    this.removeUnTrainSample = []
                    this.total3 = response.data.data.total
                    this.currentTotal3 = this.unTrainData.length
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        nextPageUnTrainData() {
            this.currentUnTrainDataFalse ++
            this.queryTrainDataFalse(1)
        },
        queryIntentionList(type) {
            if(type == 0 || type ==2 || type == 3 || type == 4){
                this.intentionListData = []
                this.checkedHasTrainList = []
                this.checkAll1 = false
                this.checkedUnTrainList = []
                this.checkAll2 = false
            }
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/list', 
                    params: {
                        current: this.current1,
                        size: this.size,
                        keyword: this.keyword,
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.intentionListData.push(...response.data.data.records)
                    this.total1 = response.data.data.total
                    this.currentTotal1 = this.intentionListData.length
                    if(type == 0 || type == 2 || type == 4 && this.intentionListData.length > 0){
                        if(type == 0){
                            this.intentionId = response.data.data.records[0].id
                            this.selectItem = 0
                        }else if(type == 2){
                            this.selectItem = response.data.data.records.length-1
                        }
                        this.currentTrainDataTrue = 1
                        this.currentUnTrainDataFalse = 1
                        this.queryNewTrainDataTrue(0)
                        this.queryTrainDataTrue(0)
                        this.queryTrainDataFalse(0)
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        showModal() {
            this.intentionModal = true
        },
        handleOk() {
            this.axios.post('/api/intention', {
                id: '',
                name: this.intentionName,
                projectId: this.projectId
            })
            .then(response=> {
                this.intentionModal = false
                if(response.data.code == 0){
                    this.intentionName = ''
                    this.intentionId = response.data.data.id
                    this.queryIntentionList(2)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        handleCancel() {
            this.visible = false
            this.ifShowEditNameModel = false
        },
        startTrain() {
            this.currentTrainState = true
            this.axios.post('/api/intention/train', {
                projectId: this.projectId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryTrainSample()
                    this.$message.success('训练成功');
                    this.queryTrainDataTrue(0)
                     this.queryNewTrainDataTrue(0)
                    this.queryTrainDataFalse(0)
                }else{
                    this.currentTrainState = false
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                this.currentTrainState = false
                console.log(error)
            })
        },
        queryTrainSample() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/statistic', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.trainedCount = response.data.data.trainedCount
                    this.unTrainedCount = response.data.data.unTrainedCount
                    this.trainTime = response.data.data.trainTime
                    this.currentTrainState = (response.data.data.trainStatus=='TRAINING'?true:false)
                }else{
                    this.$message.error(response.data.message);
                    this.currentTrainState = false
                }
            })
            .catch(error=> {
                this.currentTrainState = false
                console.log(error)
            }) 
        },
        addIntoSample(type) {
            if(type == 1 || type == 2){
                let currentContent = ''
                if(type == 1){
                    if(this.intentionId == ''){
                        this.$message.error('请先选择意图信息');
                        return false
                    }else{
                        currentContent = this.content
                    }
                }else{
                    this.selectedSampleStr = ''
                    this.selectedSampleList.map((item)=>{
                        this.selectedSampleStr += item + "\n"
                    })
                    currentContent = this.selectedSampleStr
                }
                this.axios.post('/api/intention/sample', {
                    intentionId: this.intentionId,
                    content: currentContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.content = ''
                        this.queryIntentionList(4)
                        this.queryTrainSample()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }else{
                let arr = []
                let reduceObj = {}
                for(let i = 0; i < this.selectedSupportList.length; i++){
                    let obj = {}
                    obj['content'] = this.selectedSupportList[i].split('@@')[0]
                    obj['intentionId'] = this.selectedSupportList[i].split('@@')[1]
                    arr.push(obj)
                    reduceObj[this.selectedSupportList[i].split('@@')[0]] = true
                }
                this.axios.post('/api/intention/dateSample', {
                    projectId: this.projectId,
                    sampleList: arr
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.ifTrainState = 2
                        this.queryIntentionList(4)
                        this.queryTrainSample()
                        this.$message.success('加入成功')
                        this.checkedSupportList = []
                        this.selectedSupportList = []
                        this.checkAll3 = false
                        let newArrList = []
                        for(let i = 0; i < this.sampleList.length; i++){
                            if(reduceObj[this.sampleList[i]['content']]==undefined){
                                newArrList.push(this.sampleList[i])
                            }
                        } 
                        this.sampleList = newArrList
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        selectCurrent(item,key) {
            this.intentionId = item.id
            this.currentTrainDataTrue = 1
            this.currentUnTrainDataFalse = 1
            this.currentNewTrainDataTrue = 1
            this.queryNewTrainDataTrue(0)
            this.queryTrainDataTrue(0)
            this.queryTrainDataFalse(0)
            this.selectItem = key
            this.searchKeyword = ''
            this.currentSampleData = []
            this.selectedSampleList = []
            this.searchCurrent = 1
            this.checkedHasTrainList = []
            this.checkAll1 = false
            this.checkedUnTrainList = []
            this.checkAll2 = false
        },
        querySampleList(type) {
            this.ifshowLoadSample = true
            if(type == 0){
                this.searchCurrent = 1
                this.currentSampleData = []
            }
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/sample/searchByKeyword', 
                    params: {
                        current: this.searchCurrent,
                        size: this.size,
                        projectId: this.projectId,
                        keyword: this.searchKeyword,
                        intentionId: this.intentionId
                    }
                }
            )
            .then(response=> {
                this.ifshowLoadSample = false
                if(response.data.code == 0){
                    this.currentSampleData.push(...response.data.data.records)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        loadMoreSample() {
            this.searchCurrent ++
            this.querySampleList(1)
        },
        confirmDelete(id) {
            this.$confirm({
                title: '提示',
                content: '确认要删除吗？',
                okText: '确认',
                cancelText: '取消',
                icon: 'warning',
                onOk: ()=> {
                    this.removeIntention(id)
                },
            })
        },
        showEditNameModel(name,id) {
            this.newIntentionName = name
            this.ifShowEditNameModel = true
            this.currentIntentionId = id
        },
        sureChangeName() {
            this.axios.post('/api/intention', {
                id: this.currentIntentionId,
                name: this.newIntentionName,
                projectId: this.projectId
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.newIntentionName = ''
                    this.ifShowEditNameModel = false
                    this.queryIntentionList(3)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        removeIntention(id) {
            this.axios.post('/api/intention/delete', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryIntentionList(0)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        offIntention() {
            this.intentionModal = false
        },
        saveToSelf(id){
            this.intentionModal = false
            this.axios.post('/api/public/intention', {
                intentionId: id,
                projectId: this.projectId
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryIntentionList(0)
                    this.$message.success('保存成功');
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
            console.log(error)
            })
        },
        onSearch() {
            this.intentionSampleList = []
            this.keyword = this.keywordValue
            this.sampleKeyword = ''
            this.current = 1
            this.queryData(0)
        },
        handleSelectChange1(value) {
            this.intentionSampleList = []
            this.sceneId = value
            this.current = 1
            this.queryData(0)
        },
        handleSelectChange2(value) {
            this.intentionSampleList = []
            switch(value){
                case '1':
                this.minSampleCount = 1
                this.maxSampleCount = 20
                break;
                case '2':
                this.minSampleCount = 21
                this.maxSampleCount = 50
                break;
                case '3':
                this.minSampleCount = 51
                this.maxSampleCount = 200
                break;
                case '4':
                this.minSampleCount = 201
                this.maxSampleCount = 500
                break;
                case '5':
                this.minSampleCount = 500
                this.maxSampleCount = ''
                break;
                default:
                this.minSampleCount = ''
                this.maxSampleCount = ''
                break;
            }
            this.current = 1
            this.queryData(0)
        },
        onChangeSample1() {
            this.current ++
            this.queryData(1)
        },
        queryData(type) {
            if(type == 0){
                this.data = []
                this.ifShowLoadMore2 = false
                this.total2 = 0
            }
            this.axios(
                {
                method:'get',
                url:'/api/public/intention/list', 
                params:{
                    keyword:this.keyword,
                    sceneId:this.sceneId,
                    minSampleCount:this.minSampleCount,
                    maxSampleCount:this.maxSampleCount,
                    sampleKeyword:this.sampleKeyword,
                    current:this.current,
                    size:10,
                }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                this.data.push(...response.data.data.records)
                this.total4 = response.data.data.total
                if(this.total4 == this.data.length){
                    this.ifShowLoadMore1 = false
                }else{
                    this.ifShowLoadMore1 = true
                }
                }else{
                this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySampleData(type) {
            if(type == 0){
                this.intentionSampleList = []
                this.countTotalNum2 = 0
            }
            this.axios(
                {
                method:'get',
                url:'/api/public/intention/sample/list', 
                params: {
                    current: this.currentSample,
                    size: 20,
                    intentionId: this.recordData.id
                }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                this.intentionSampleList.push(...response.data.data.records)
                this.total2 = response.data.data.total
                this.countTotalNum2 = this.intentionSampleList.length
                if(this.intentionSampleList.length == this.total2){
                    this.ifShowLoadMore2 = false
                }else{
                    this.ifShowLoadMore2 = true
                }
                }else{
                this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        rowClick: function(record){
            return {
                on: {
                click: () => {
                    this.recordData = record
                    this.currentSample = 1
                    this.querySampleData(0)
                    this.currentId = record.id
                }
                }
            }
        },
        onChangeSample2() {
            this.currentSample ++
            this.querySampleData(1)
        },
        queryProDataList() {
            this.axios.get('/api/dropdown/project')
            .then(response=> {
                if(response.data.code == 0){
                this.proList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySence() {
            this.axios.get('/api/dropdown/scene')
            .then(response=> {
                if(response.data.code == 0){
                this.sceneList = response.data.data

                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeRecommendText(date, dateString) {
            this.startTime = dateString[0]
            this.endTime = dateString[1]
            this.selectPriceDate = ''
        },
        filterSample() {
            this.searchContent = this.trim(this.searchContent)
             this.queryNewTrainDataTrue(0)
            this.queryTrainDataTrue(0)
            this.queryTrainDataFalse(0)
        },
        trim(str){
            return str.replace(/(^\s*)|(\s*$)/g, '');
        },
        cancelRequestTrue(){
            if(typeof this.sourceTrue ==='function'){
                this.sourceTrue('终止请求')
            }
        },
        cancelRequestFalse(){
            if(typeof this.sourceFalse ==='function'){
                this.sourceFalse('终止请求')
            }
        },
    },
    mounted: function() {
        this.sessionData('set','contentNavItem','api');
        this.projectId = this.$route.query.projectId
        this.queryIntentionList(0)
        this.queryTrainSample()
        this.querySence()
        this.queryData(1)
        if(this.sessionData('get','token')){
            this.queryProDataList()
            this.isLogin = true
        }else{
            this.isLogin = false
        }
    }
}
</script>

<style scoped lang="less">
    .ant-checkbox-group{
        width: 100% !important;
    }
    .intention-train{
        height: 100%;
        background: #F5F5F5;
        padding: 24px;
        .content{
            width: 100%;
            height: 100%;
            background: #fff;
            display: flex;
            padding: 24px 32px 0px;
            border-radius: 8px;
			flex-direction: column;
            .title{
                width: 100%;
                height: 42px;
                border-bottom: 1px solid rgba(240, 240, 240, 1);
                .msg-head{
                    color: rgba(51, 51, 51, 1);
                    font-size: 18px;
                    float: left;
                    font-weight: bold;
                }
                .info{
                    text-align: right;
                    font-size: 12px;
                    color: rgba(204, 204, 204, 1);
                    float: right;
                    .train{
                        background: rgba(34, 215, 187, 1);
                        font-size: 14px;
                        color: #fff !important;
                        height: 34px;
                        width: 60px;
                        line-height: 34px;
                        border-radius: 4px;
                        padding: 0px;
                        width: 80px;
                        text-align: center;
                    }
                }
            }
            .msg{
                flex: 1;
                display: flex;
                .gutter-example{
                    width: 100%;
                    height: 100%;
                    .ant-row{
                        height: 100%;
                    }
                    .gutter-row{
                        height: 100%;
                    }
                    .gutter-box {
                        height: 100%;
                        border-radius: 4px;
                        padding: 24px 0 24px;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        .span-icon{
                            display: block;
                            margin: 0 auto;
                            width: 100px;
                            height: 32px;
                            background: rgba(34, 215, 187, 1);
                            font-size: 14px;
                            color: #fff;
                            line-height: 32px;
                            text-align: center;
                            margin-top: 3px;
                            border-radius: 4px;
                            cursor: pointer;
                        }
                        .box-head{
                            height: 68px;
                            .intention-search{
                                margin-top: 11px;
                                .intention-input{
                                    float: left;
                                    border: none !important;
                                }
                            }
                            .intention-tab{
                                margin-top: 11px;
                                border-radius: 4px;
                                overflow: hidden;
                                border: 1px solid rgba(34, 215, 187, 1);
                                display: inline-block;
                                float: left;
                                span{
                                    width: 88px;
                                    cursor: pointer;
                                    height: 32px;
                                    line-height: 32px;
                                    text-align: center;
                                    display: inline-block;
                                    font-size: 14px;
                                    box-shadow: rgba(34, 215, 187, 1) solid 1px;
                                    background: #fff;
                                }
                                span.active{
                                    background: rgba(34, 215, 187, 1);
                                    color: #fff;
                                }
                            }
                        }
                        .box-content{
                            flex: 1;
                            border: rgba(238, 238, 238, 1) solid 1px;
                            overflow-y: auto;
                            margin-top: 28px;
                            position: relative;
                            li{
                                line-height: 30px;
                                padding-left: 10px;
                                height: 30px;
                                div{
                                    display: inline-block;
                                    float: right;
                                    i{
                                        margin-left: 10px;
                                        cursor: pointer;
                                        height: 30px;
                                    }
                                }
                                .li-des{
                                    padding-left:5px;
                                    width: 100px;
                                    display: inline-block;
                                    float: right;
                                    span{
                                        display: inline-block;
                                        width: 40px;
                                        float: left;
                                    }
                                    i{
                                        float: left;
                                        line-height: 33px;
                                        display: none;
                                    }
                                }
                                label{
                                    // float: left;
                                    // span{
                                    //     float: left;
                                        
                                    // }
                                }
                            }
                            li:hover{
                                div{
                                    padding-right: 0px;
                                }
                                i{
                                    display: inline-block;
                                }
                            }
                            i:hover{
                                color: rgba(34, 215, 187, 1);
                            }
                            li:nth-child(odd){
                                background: rgba(238, 238, 238, 0.5);
                            }
                            li.active{
                                background: #22d7bb !important;
                                color: #fff;
                            }
                        }
                        .add-sample{
                            background: #fff;
                            li:nth-child(odd){
                                background: rgba(238, 238, 238, 0.5);
                            }
                        }
                        .box-foot{
                            margin-top:24px;
                            height:37px;
                            button{
                                display: block;
                                margin: 0px auto;
                                height:34px;
                                border-color: rgba(34, 215, 187, 1);
                                background-color: rgba(34, 215, 187, 1);
                                color: #fff !important;
                            }
                        }
                        .intention-list-head{
                            color: rgba(80, 80, 80, 1);
                            font-size: 16px;
                        }
                    }
                }
                
            }
        }
          
    }
    .intention-content{
        width: 100%;
        margin: 0 auto;
        height: 100%;
        background: #fff;
        border-radius: 4px;
        .gutter-box{
            background: #fff;
            overflow-y: auto;
            flex: 1;
            flex-direction: column;
            .cloudy-table{
                div.active{
                color: #22d7bb;
                }
                table div{
                cursor: pointer;
                }
                td,th{
                padding: 0px !important;
                }
            }
            .table-sample{
                i{
                display: none;
                float: right;
                margin-top:5px;
                }
                div:hover{
                i{
                    display: inline-block;
                }
                }
            }
            td,th{
                padding-top: 8px;
                padding-bottom: 8px;
            }
            .title{
                font-size: 14px;
                font-weight: bold;
                color: rgba(80, 80, 80, 1);
                margin-bottom: 15px;
            }
            .sample{
                overflow-y: auto;
            }
        }
    }
    .box-model-foot{
         button{
            display: block;
            margin: 0px auto;
            height:34px;
            border-color: rgba(34, 215, 187, 1);
            background-color: rgba(34, 215, 187, 1);
            color: #fff !important;
        }
    }
</style>
